import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import I404Png from "./../images/404Basil.png";
import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from "@headlessui/react";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";
import MenuScheduleFilter from "./MenuScheduleFilter";
import { HiOutlineCog } from "react-icons/hi";
import { Drawer } from "@mui/material";
import SidePanelContent from "./SidePanelContent";
import Cookies from "js-cookie";
import NcImage from "shared/NcImage/NcImage";

export interface menuSchedule {
  menuDay: string;
  fromTime: any;
  toTime: any;
}
interface Category {
  id: number;
  name: string;
  isDeleted: boolean;
  createdBy: number;
  createdDate: string;
  modifiedBy?: number;
  modifiedDate?: string;
  items?: Item[];
  modifierSetIds?: any[];
}
interface Item {
  name: string;
  price: number;
}
interface MerchantStore {
  logoUrl?: string;
  orderLeadTime?: number;
  image?: string;
  title?: string;
  customTextOne?: string;
  pauseOnlineOrder?: boolean;
  pauseOnlineOrderLabel?: string;
  onlineDeliveryId?: string;
  isDelivery?: boolean;
  subTitle?: string;

  // Add other properties if necessary
}
export interface Product {
  id: number;
  name: string;
  price: number;
  onlinePrice: number;
  image: string;
  description: string;
  category: string;
  tags: string[];
  link: "/:merchantname/product-detail";
  //   variants?: ProductVariant[];
  variantType?: "color" | "image";
  sizes?: string[];
  allOfSizes?: string[];
  status?: "New in" | "limited edition" | "Sold Out" | "50% Discount";
  imageUrl?: string;
  isAvailable?: number | undefined;
  sku?: string;
  //   unit?: Unit;
  //   priceType?: PriceType;
  color?: string;
  isDeleted?: boolean;
  createdBy?: number;
  createdDate?: string;
  modifiedBy?: number;
  modifiedDate?: string;
  //   modifierSets?: ModifierSets[];
  //   taxes?: Tax[];
  //   printers?: Printer[];
  quantity?: number;
  modifierChecked?: any;
  items?: Item[];
  note?: string;
  cartItemId?: number;
}

interface ResponseData {
  merchantStore: MerchantStore;
  items: any[];
  all: any[];
  menus: any[];
}

const QRMenu: React.FC = () => {
  const [categories, setCategories] = useState<Category[]>([]);
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [menuScheduleData, setMenuScheduleData] = useState<menuSchedule[]>([]);
  const [menus, setMenus] = useState<any[]>([]);
const [selectedMenu, setSelectedMenu] = useState<any | null>(null);
  const [selectedSchedule, setSelectedSchedule] = useState<
    menuSchedule[] | null
  >(null);
  const [selectedCategoryId, setSelectedCategoryId] = useState<number | null>(
    null
  );
  const [isOpen, setIsOpen] = useState(false);
  const [isHamburgerOpen, setIsHamburgerOpen] = useState(false);
  const [scrollId, setScrollId] = useState<number | null>(null);
  const [hasError, setHasError] = useState(false);
  const [isopen, setIsopen] = useState(false);
  const [popUpContent, setPopUpContent] = useState<any>();
  const [onlineOrderSettings, setOnlineOrderSettings] =
    useState<MerchantStore | null>(null);
  const isMode = Cookies.get("theme");
  const [showRightArrow, setShowRightArrow] = useState(false);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const pathname = window.location.pathname;
  const merchantName = pathname.split("/")[1];
  useEffect(() => {
    const fetchData = async () => {
      try {
        const apiUrl = `/menu/qr`;
        // const menuUrl = `/menuSchedule/type/onlineOrdering`;
        const baseurl = `https://basil-backoffice-dev.com/api`;
        const response = await axios.get(
          baseurl + apiUrl,

          {
            headers: {
              "Content-Type": "application/json",
              MID: merchantName,
            },
          }
        );
      
        const menusData = (response.data as ResponseData)?.menus || [];
        setMenus(menusData);
       if (menusData.length > 0) {
  console.log("menusData", menusData,menusData.map((menu: any) => menu.categories?.length>0 && menu?.menuName));
          setSelectedMenu(menusData[0]);
          const initialCategories = menusData[0]?.categories || [];
          
          // Sort items in each category for initial menu
          const categoriesWithSortedItems = initialCategories.map((category: any) => ({
            ...category,
            items: category.items ? sortItemsAlphabetically(category.items) : []
          }));
          
          setCategories(categoriesWithSortedItems);
          setSelectedCategoryId(
            categoriesWithSortedItems?.[0]?.id || null
          );
        } 

        setMenuScheduleData(response?.data?.merchantStore?.storeHours as menuSchedule[]);
        const obtainedData = (response.data as ResponseData)
          ?.merchantStore;
          // console.log((response.data as ResponseData)?.all,(response.data as ResponseData)?.menus[0])
        const itemData = (response.data as ResponseData)?.all !== null? (response.data as ResponseData)?.all : (response.data as ResponseData)?.menus[0].categories;
        console.log(response.data,itemData, "itemData");
        if (itemData.length === 0) {
          setHasError(true);
        } else {
          const filteredCategories = itemData?.filter(
             (category: { items: any[] }) => category?.items && category?.items?.length > 0
          );
          
          // Sort items in each category
          const categoriesWithSortedItems = filteredCategories.map((category: any) => ({
            ...category,
            items: sortItemsAlphabetically(category.items || [])
          }));
          
          console.log("filteredCategories", categoriesWithSortedItems);
          const onlineData = obtainedData as MerchantStore;
          setCategories(categoriesWithSortedItems);
          if (filteredCategories.length > 0) {
            setSelectedCategoryId(filteredCategories[0].id);
          }
          setOnlineOrderSettings({
            ...onlineData,
            customTextOne: onlineData?.subTitle ?? "",
          });
          if (onlineData?.logoUrl) {
            localStorage.setItem("onlineOrderSettingsLogo", onlineData?.logoUrl);
          }
        }
      } catch (error) {
        setHasError(true);
        console.error("Error fetching online order settings:", error);
      } finally {
        // setLoading(false);
      }
    };
    fetchData();
  }, []);
 
// const hamburger = () => {
//   console.log(menus, "menus");
// };

// // run when drawer opens
// useEffect(() => {
//   if (isHamburgerOpen) {
//     hamburger();
//   }
// }, [isHamburgerOpen]); 
  const modifierSetsContent = () => {
    // Sort modifier sets: by orderBy if valid, otherwise alphabetically
    const sortedModifierSets = popUpContent?.modifierSets?.slice().sort((a: any, b: any) => {
      const orderByA = a.orderBy;
      const orderByB = b.orderBy;
      
      // Check if orderBy is valid (not null, not undefined, not empty string, not 999)
      const isValidOrderByA = orderByA != null && orderByA !== '' && orderByA !== 999;
      const isValidOrderByB = orderByB != null && orderByB !== '' && orderByB !== 999;
      
      // If both have valid orderBy, sort by orderBy first
      if (isValidOrderByA && isValidOrderByB) {
        if (orderByA !== orderByB) {
          return orderByA - orderByB;
        }
        // If orderBy values are the same, sort alphabetically
        return (a.name || '').localeCompare(b.name || '');
      }
      
      // If only one has valid orderBy, prioritize it
      if (isValidOrderByA && !isValidOrderByB) return -1;
      if (!isValidOrderByA && isValidOrderByB) return 1;
      
      // If neither has valid orderBy, sort alphabetically
      return (a.name || '').localeCompare(b.name || '');
    }) || [];
    
    return (
      <>
        {sortedModifierSets.map((modifier: any, index: number) => {
          return (
            <Disclosure key={index}>
              {({ open }) => (
                <>
                  <DisclosureButton className="flex items-center justify-between w-full px-4 py-2 font-medium text-right bg-slate-100/80 hover:bg-slate-200/60 dark:bg-slate-800 dark:hover:bg-slate-700 rounded-lg focus:outline-none focus-visible:ring focus-visible:ring-slate-500 focus-visible:ring-opacity-75 ">
                    <span>
                      {modifier.name}
                      {modifier.noOfRequired > 0 && (
                        <span className="text-sm font-normal ml-auto">
                          (required {modifier.noOfRequired})
                        </span>
                      )}
                    </span>
                    {modifier.noOfRequired > 0 && (
                      <span className="text-sm font-normal ml-auto">
                        {" "}
                        upto {modifier.maximum}{" "}
                      </span>
                    )}
                    {modifier.noOfRequired === 0 && (
                      <span className="text-sm font-normal ml-auto">
                        optional, upto {modifier.maximum}
                      </span>
                    )}
                    {!open ? (
                      <FaAngleDown className="w-4 h-4 text-slate-600 dark:text-slate-400" />
                    ) : (
                      <FaAngleUp className="w-4 h-4 tezxt-slate-600 dark:text-slate-400" />
                    )}
                  </DisclosureButton>
                
                  {modifier?.modifierSetModifierItems
  ?.slice()
  .sort((a:any, b:any) => (a.orderBy ?? 0) - (b.orderBy ?? 0)) // ascending
  .map((modifierName: any) => (
    <DisclosurePanel
      key={modifierName.id}
      className="p-4 pt-3 last:pb-0 text-slate-600 text-sm dark:text-slate-300 leading-6 flex items-center justify-between"
    >
      <div className="flex justify-between w-full">
        <span>{modifierName.modifierItem?.name}</span>
        <span>${modifierName.modifierItem?.price}</span>
      </div>
    </DisclosurePanel>
))}
                </>
              )}
            </Disclosure>
          );
        })}
      </>
    );
  };
  const handlePopup = (data: any) => {
    setIsopen(true);
    setPopUpContent(data);
  };

  useEffect(() => {
    if (categories.length > 0 && selectedCategoryId === null) {
      const firstCategoryId = categories[0].id;
      setSelectedCategoryId(firstCategoryId); // Set the default category on page load
    }
  }, [categories]);

  const handlemenuSchedule = () => {
    if (menuScheduleData) {
      setSelectedSchedule(menuScheduleData);
      setModalOpen(true);
    }
  };

  const isOpenNow = (fromTime: string, toTime: string): boolean => {
    if (!fromTime || !toTime) return false;

    const now = new Date();
    const [fromHours, fromMinutes] = fromTime.split(":").map(Number);
    const [toHours, toMinutes] = toTime.split(":").map(Number);

    const fromDate = new Date(now);
    fromDate.setHours(fromHours, fromMinutes, 0, 0);

    const toDate = new Date(now);
    toDate.setHours(toHours, toMinutes, 0, 0);

    // Handle overnight shift (e.g., 22:00 to 02:00)
    if (toDate <= fromDate) {
      toDate.setDate(toDate.getDate() + 1);
    }

    return now >= fromDate && now <= toDate;
  };

  const getCurrentDay = (): string => {
    const daysOfWeek = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    const currentDayIndex = new Date().getDay();
    return daysOfWeek[currentDayIndex];
  };

  const currentStatus = () => {
    const currentDay = getCurrentDay();
    if (!menuScheduleData) return { text: "Closed", color: "red" };

    const todaySchedules = menuScheduleData.filter(
      (schedule) => schedule.menuDay === currentDay
    );

    const isCurrentlyOpen = todaySchedules.some((schedule) =>
      isOpenNow(schedule.fromTime, schedule.toTime)
    );

    return {
      text: isCurrentlyOpen ? "Open" : "Closed",
      color: isCurrentlyOpen ? "#7BB542" : "red",
    };
  };

  const status = currentStatus();

  // Function to sort items by first letter or number
  const sortItemsAlphabetically = (items: any[]) => {
    return items.slice().sort((a, b) => {
      const nameA = (a.name || '').trim().toLowerCase();
      const nameB = (b.name || '').trim().toLowerCase();
      
      // Get first character of each name
      const firstCharA = nameA.charAt(0);
      const firstCharB = nameB.charAt(0);
      
      // Check if first character is a number
      const isNumberA = /^[0-9]/.test(firstCharA);
      const isNumberB = /^[0-9]/.test(firstCharB);
      
      // Numbers come before letters
      if (isNumberA && !isNumberB) return -1;
      if (!isNumberA && isNumberB) return 1;
      
      // If both are numbers or both are letters, sort normally
      return nameA.localeCompare(nameB);
    });
  };

  const selectedCategory =
    categories.find((category) => category.id === selectedCategoryId) ||
    categories[0]; // Fallback to the first category
  
  // Sort items in the selected category
  const sortedItems = selectedCategory?.items ? sortItemsAlphabetically(selectedCategory.items) : [];
  console.log("selectedCategory: ", selectedCategory);

  const handleCategorySelect = (categoryId: any) => {
    setSelectedCategoryId(categoryId); // Set the selected category ID
  };

  const headerRef = useRef(null);
  const [contentHeight, setContentHeight] = useState("auto");

  useEffect(() => {
    const updateContentHeight = () => {
      if (headerRef.current) {
        const headerHeight = (headerRef.current as HTMLDivElement).offsetHeight;
        const viewportHeight = window.innerHeight;
        const newHeight = viewportHeight - headerHeight;
        setContentHeight(`${newHeight - 55}px`);
      }
    };

    // Initial calculation
    updateContentHeight();

    // Update on resize
    window.addEventListener("resize", updateContentHeight);
    return () => window.removeEventListener("resize", updateContentHeight);
  }, []);
  useEffect(() => {
    document.body.style.overflow = isopen ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isopen]);
 
  return (
    <>
      {hasError === true ? (
        <div className="nc-Page404 fixed inset-0 flex items-center justify-center bg-white dark:bg-neutral-900 overflow-hidden z-50">
          <div className="text-center px-4 max-w-md w-full">
            <img src={I404Png} className="mx-auto mb-4 max-w-xs" alt="404 Not Found" />
            <span className="block text-lg text-neutral-800 dark:text-neutral-200 tracking-wider font-bold">
              The business you are looking for was not found. Please check the
              link and try again.
            </span>
            <div className="pt-8">

            </div>
          </div>
        </div>
      ) : (
        <>


          <div className="fixed inset-0 flex flex-col bg-white dark:bg-neutral-900 z-50">

            <div className="nc-HeaderLogged sticky top-0 z-40 ">
              <div className="nc-MainNav2Logged relative z-10 bg-white dark:bg-neutral-900 border-b border-slate-100 dark:border-slate-700">
                <div className="container">
                  <div className="h-20 flex justify-between">
                    <div className="flex items-center justify-start">
                        
                      <a
                        className="ttnc-logo inline-block text-slate-600"
                        href={`/${merchantName}`}

                      >
                        {onlineOrderSettings?.logoUrl && (
                          <img
                            src={onlineOrderSettings.logoUrl}
                            alt="Logo"
                            className="block h-10 sm:h-14 max-h-14 dark:text-gray-100 rounded-lg"
                          />
                        )}
                      </a>
                    </div>
                    <div className="flex-[2] hidden lg:flex justify-center mx-4"></div>
                    <div className="flex-1 flex items-center justify-end text-slate-700 dark:text-slate-100">
                      <div className="lg:flex">
                        <div
                          className="text-2xl"
                          onClick={() => setIsOpen(true)}
                        >
                          <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800 focus:outline-none flex items-center justify-center cursor-pointer">
                            <HiOutlineCog />
                          </div>
                        </div>
                        <Drawer
                          anchor="right"
                          open={isOpen}
                          sx={{ "& .MuiDrawer-paper": { width: "300px" } }}
                        >
                          <SidePanelContent setIsOpen={setIsOpen} />
                        </Drawer>
                      </div>
                    </div>

                    <div className="flex lg:hidden sm:flex sm:items-center lg:flex-1  justify-center mx-auto my-4">

                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="main-content flex-grow pb-10"> */}
            <div className="main-content flex-grow overflow-y-auto pb-10">
              <div className="nc-PageHome relative">
                <div className="container relative space-y-10 my-6 lg:space-y-10 lg:my-10">
                  <div className="nc-PageHomeMenu relative">
                    <div className="flex flex-col relative mb-12">
                      {/* Title and Subtitle Section */}
                      <div className="text-center mb-6">
                        {onlineOrderSettings?.title && (
                          <h1 className="text-3xl sm:text-4xl font-bold text-gray-800 dark:text-gray-200 mb-2">
                            {onlineOrderSettings.title}
                          </h1>
                        )}
                        {onlineOrderSettings?.customTextOne && (
                          <p className="text-lg sm:text-xl text-gray-600 dark:text-gray-400 max-w-2xl mx-auto">
                            {onlineOrderSettings.customTextOne}
                          </p>
                        )}
                      </div>

                      <div className="relative w-full">
                        {onlineOrderSettings && (
                          <div className="relative w-full">

                            <div className="absolute top-0 left-0 w-full h-full flex flex-col justify-center items-center text-cream text-center">

                            </div>
                          </div>
                        )}
                      </div>
                      <div className="flex items-center space-x-2 mt-4 mb-2">
                        <h3
                          className="px-3 py-1 rounded-lg"
                          style={{
                            backgroundColor: status?.color,
                          }}
                        >
                          {status?.text}
                        </h3>
                        <button
                          onClick={handlemenuSchedule}
                          className="bg-grey-500 dark:text-gray-100 px-3 py-1 rounded-lg focus:outline-black focus:ring focus:ring-grey"
                        >
                          Hours
                        </button>
                      </div>
                      <div className="flex flex-col lg:flex-row lg:items-center justify-between space-y-6 lg:space-y-0 lg:space-x-2">
                        <div
                          className="overflow-x-auto whitespace-nowrap flex py-2 items-center relative"
                          ref={headerRef}
                        >
                        
                     {menus?.length > 0 && (
  <button
     onClick={() => setIsHamburgerOpen(true)}
    className="p-2 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-700"
  >
    ☰
  </button>
)}
                   
                <Drawer
  anchor="left"
  open={isHamburgerOpen}
  onClose={() => setIsHamburgerOpen(false)}
  ModalProps={{
    keepMounted: true, // improves performance
    BackdropProps: {
      style: {
        backgroundColor: "rgba(0, 0, 0, 0.5)", // dim/overlay the page
        backdropFilter: "blur(2px)", // optional: blur the background
      },
    },
  }}
  sx={{
    "& .MuiDrawer-paper": {
      width: "250px",
      backgroundColor: "var(--drawer-bg, white)", // make sure drawer itself is opaque
    },
  }}
>
  <div className="p-4 h-full bg-white dark:bg-gray-900">
    <h2 className="text-lg font-semibold mb-4 text-gray-900 dark:text-gray-100">
      MENUS
    </h2>
    <div className="flex flex-col gap-2">
      {menus
        .filter((menu: any) => menu?.categories?.length > 0)
        .map((menu: any) => (
          <div
            key={menu.id}
            onClick={() => {
              setSelectedMenu(menu);
              const menuCategories = menu?.categories || [];
              
              // Sort items in each category when switching menus
              const categoriesWithSortedItems = menuCategories.map((category: any) => ({
                ...category,
                items: category.items ? sortItemsAlphabetically(category.items) : []
              }));
              
              setCategories(categoriesWithSortedItems);
              setSelectedCategoryId(categoriesWithSortedItems?.[0]?.id || null);
              setIsHamburgerOpen(false);
            }}
            className={`cursor-pointer px-2 py-1 rounded hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-900 dark:text-gray-100 ${
              selectedMenu?.id === menu.id ? "font-bold text-blue-500" : ""
            }`}
          >
            {menu.menuName}
          </div>
        ))}
    </div>
  </div>
</Drawer>



                          {categories?.map((category) => (
                            <div className="mx-3" key={category.id}>
                              <div
                                key={category.id}
                                onClick={() =>
                                  setSelectedCategoryId(category.id)
                                }
                                className={`inline-block cursor-pointer transition-colors duration-300 px-2 py-1 rounded ${selectedCategory?.id === category.id
                                  ? "border-b-2 border-black text-black font-bold dark:text-gray-100 hover:bg-gray-200 dark:hover:text-black"
                                  : "text-neutral-700 font-semibold hover:bg-gray-200 dark:text-gray-100 dark:hover:text-black"
                                  }`}
                              >
                                 
                                {category.name}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="grid gap-4 sm:gap-8 grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
                    {sortedItems?.map((item: any, index: any) => (
                      <div key={index} className="nc-ProductCard relative flex flex-col bg-transparent">
                        <div className="flex flex-col items-center md:items-start">
                          <div className="bg-[#ddd] h-[130px] md:h-[224px] w-[130px] md:w-[224px] rounded-3xl flex items-center justify-center mx-auto mb-3">
                            <div className="group h-full w-full relative cursor-pointer">
                              <NcImage
                                src={item.imageUrl || ""}
                                className="object-cover w-full h-full drop-shadow-lg rounded-3xl transform transition-transform duration-300 group-hover:scale-110"
                                containerClassName="flex aspect-w-1 aspect-h-1 w-full h-10"
                                onClick={() => handlePopup(item)}
                              />
                            </div>
                          </div>
                          <div className="space-y-1 px-2.5 pt-2 w-full">
                            <div className="text-center">
                              <div
                                className="font-semibold text-sm pt-1 truncate w-full px-2"
                                title={item.name}
                              >
                                {item.name}
                              </div>
                              <div className="text-xs font-semibold pt-0">
                                <div className="flex justify-center items-center">
                                  <div className="flex flex-col items-center py-1 px-4 md:px-2.5 text-sm font-medium">
                                    <span>${item.price?.toFixed(2)}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    ))}

                    <div className="col-span-full mt-4">
                      <p className="text-sm text-black font-bold text-left dark:text-white">
                        <span className="text-red-500">*</span> All prices displayed are cash prices
                      </p>
                    </div>

                  </div>

                </div>
              </div>
            </div>
          </div>

          {isopen && (
            <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50 ">
              <div className="bg-white p-6 rounded-lg shadow-lg max-w-lg w-full mx-4 sm:mx-8 max-h-[90vh] overflow-y-auto relative dark:bg-neutral-700">
                {/* Close Button */}
                <button
                  className="absolute top-3 right-3 text-gray-800 dark:text-white"
                  onClick={() => setIsopen(false)}
                >
                  &times;
                </button>

                <div className="flex">
                  {/* Image */}
                  <NcImage
                    src={popUpContent?.imageUrl}
                    className="w-[130px] h-32 object-cover mb-2 "
                    alt={popUpContent?.name}
                  />
                  <div>
                    <h2 className="text-lg sm:text-lg font-semibold ml-4 break-words max-w-[250px]">
                      {popUpContent?.name}
                    </h2>
                    <p className="py-1 px-2 md:py-1.5 md:px-3 text-md font-semibold">
                      ${popUpContent?.price.toFixed(2)}
                    </p>
                    <p className="py-1 px-2 md:py-1.5 md:px-3 text-md font-semibold">
                      {popUpContent?.description && popUpContent.description !== "Null" && (
                        <p className="py-1 px-2 md:py-1.5 md:px-3 text-md font-semibold">
                          {popUpContent.description}
                        </p>
                      )}
                    </p>
                  </div>
                </div>

                {modifierSetsContent()}
              </div>
            </div>
          )}
          {selectedSchedule && (
            <MenuScheduleFilter
              isOpen={modalOpen}
              onClose={() => setModalOpen(false)}
              menuschedule={selectedSchedule || []}
            />
          )}
        </>
      )}
    </>
  );
};

export default QRMenu;
